import {PropsWithChildren} from "react";
import {FormWrapper} from "../../../../components/form-wrapper";

export function ServiceFormLayout({
  children,
  title,
}: PropsWithChildren<{title?: string}>) {
  return (
    <div style={{maxWidth: "71.6rem"}}>
      <FormWrapper title={title}>{children}</FormWrapper>
    </div>
  );
}
